// The backend returns a "submission" object even for a recipient that
// hasn't actually been submitted to yet ({ status: "None", submissionDateTime:
// null, acceptanceDateTime: null }) - checking truthiness of the object alone
// treats every pre-submission recipient as already submitted. Only a real
// submissionDateTime means a submission genuinely happened.
export default function isCaseSubmittedTo(recipient) {
  return Boolean(recipient?.submission?.submissionDateTime);
}
